/* eslint-disable import/prefer-default-export */
export const IMPORT_METHODS = {
	URL: "url",
	SITEMAP: "sitemap",
	LOCAL_FILE: "localFile",
	SHOPIFY: "shopify"
};

export const AVAILABLES_CHANNELS = [
	{
		type: "SHFY",
		importMethod: IMPORT_METHODS.SHOPIFY
	}
];

export const SHOPIFY_RESOURCE = {
	PAGES: "pages",
	PRODUCTS: "products"
};

export const CHAT_MODAL_MODES = {
	ASSISTANT: "assistant",
	HELP: "help"
};

export const WS_EVENTS = {
	ASSET_CONVERTION_START: "asset_convertion_start",
	PIPELINE_RESULT: "faiq_pipeline_result",
	KNOWLEDGE_COUNT_TO_TRAIN: "knowledge_count_to_train",
	KNOWLEDGE_TRAIN_UPDATE: "knowledge_train_update",
	KNOWLEDGE_TRAIN_UPDATE_ERROR: "knowledge_train_update_error",
	KNOWLEDGE_TRAIN_RESULT: "knowledge_train_result",
	ASSETS_RELOAD_TABLE: "assets_reload_table",
	DISPLAY_SNACKBAR: "display_snackbar"
};
